export const proofOfConclusionAttributes = `
  id
  userId
  fleetId
  client
  imgUrls
  savedAt
  completedAt
  userName
  address
  observation
  activityId
  vehicleId
  model
  licensePlate
  vehicle {
    alias
  }
`;

export default proofOfConclusionAttributes;
